import styled, { css } from "styled-components";

export const PageWrapper = styled.div`
  min-height: 100vh;
  background: #fff;
  font-family: "Noto Sans Thai", sans-serif;
`;

export const Container = styled.div`
  background: #fff;
  // max-width: 800px;
  max-width: 800px;
  height: 70vh;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  

  @media (max-width: 768px) {
    width: 100%;
  }


`;
export const Wrapper = styled.div`
  padding: 32px 60px 20px 60px;
  text-align: center;

  /* ✅ mobile */
  @media (max-width: 768px) {
    padding: 24px 16px 20px;
    width: 100%;
  }
`;

export const Icon = styled.div`
  margin-bottom: 16px;

  img {
    width: 144px;
    height: 144px;

    @media (max-width: 768px) {
      width: 96px;
      height: 96px;
    }
  }
`;

export const Title = styled.div`
  font-size: 26px;
  line-height: 42px;
  font-weight: 600;
  margin-bottom: 12px;
  white-space: pre-line;

  @media (max-width: 768px) {
    font-size: 22px;
    line-height: 34px;
  }
  
`;

export const Desc = styled.div`
  font-size: 16px;
  color: #666;
  white-space: pre-line;
  line-height: 24px;
  margin-bottom: 20px;
`;